import { isReadingPanePositionOff } from 'owa-mail-layout/lib/selectors/readingPanePosition';
import { shouldShowReadingPane } from 'owa-mail-layout/lib/selectors/shouldShowReadingPane';
import { getSafeSelectedTableView } from 'owa-mail-list-store/lib/utils/getSelectedTableView';
import getSelectedItemParts from 'owa-mail-list-store/lib/selectors/getSelectedItemParts';
import { owaComputedFn } from 'owa-computed-fn';
import { computed } from 'mobx';
import isDeepLink from 'owa-url/lib/isDeepLink';

/**
 * @returns true if no item is selected in the list view
 */
export const isNoItemContext: () => boolean = owaComputedFn(function isNoItemContext(): boolean {
    // We are using computed here so the we don't observe selectedRowKeys but instead observe the size only.
    // This prevents us from re-computing for every click in the maillist.
    const hasNoSelectedRowKeys = computed(
        () => getSafeSelectedTableView()?.selectedRowKeys?.size === 0
    ).get();
    return (
        hasNoSelectedRowKeys &&
        !getSafeSelectedTableView()?.isInVirtualSelectAllMode &&
        !isDeepLink()
    );
});

/**
 * @param isPopOut boolean indicating if we are in the reading pane or a popout
 * @returns true if more than one item is selected in the list view or if the reading pane is hidden
 */
export const isMultipleSelection: (isPopOut: boolean) => boolean = owaComputedFn(
    function isMultipleSelection(isPopOut: boolean): boolean {
        if (isPopOut) {
            return false;
        }

        if (isReadingPaneHidden()) {
            return true;
        }

        if (getSafeSelectedTableView()?.isInVirtualSelectAllMode) {
            return true;
        }

        // We are using computed here so the we don't observe selectedRowKeys but instead observe the size only.
        // This prevents us from re-computing for every click in the maillist.
        const hasMultipleSelectedRowKeys = computed(
            () => (getSafeSelectedTableView()?.selectedRowKeys?.size ?? 0) > 1
        ).get();
        if (hasMultipleSelectedRowKeys) {
            return true;
        }

        // We are using computed here so the we don't observe selectedNodeIds but instead observe the length only.
        // This prevents us from re-computing for every click in the maillist.
        const isMultipleItemPartSelection = computed(() => getSelectedItemParts().length > 1).get();
        return isMultipleItemPartSelection;
    }
);

/**
 * @returns true if the reading pane is hidden
 */
export function isReadingPaneHidden(): boolean {
    return isReadingPanePositionOff() && !shouldShowReadingPane();
}
